import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';

import Loader from '@components/common/Loader';

export interface IAuthorizedHandlerProps {
  authorizedURLParam: string;
}

const AuthorizedHandler: FC<IAuthorizedHandlerProps> = ({ authorizedURLParam }) => {
  useEffect(() => {
    if (authorizedURLParam === 'true') {
      // close popupWindow
      (document.getElementById('closePopupWindow') as HTMLFormElement).click();
    }
  }, [authorizedURLParam]);

  return (
    <>
      <Loader />
      <button hidden id="closePopupWindow" onClick={() => window.close()} />
    </>
  );
};

export default observer(AuthorizedHandler);
